// ImageModal.jsx
import React from 'react';
import '../../css/ImageModal.css';

export default function ImageModal({ isOpen, src, onClose }) {
  if (!isOpen) return null;

  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  return (
    <div className='modal' onClick={handleOverlayClick}>
      <div className='modal-content'>
        <button className='modal-close' onClick={onClose} aria-label='Close'>
          &times;
        </button>
        {src ? (
          <img src={src} alt='Generated' className='modal-image' />
        ) : (
          <p>Loading image...</p>
        )}
      </div>
    </div>
  );
}
